/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  // Novos métodos para QR Code
  getQRCode(inboxId) {
    return axios.get(`${this.url}/${inboxId}/get_qrcode`);
  }

  checkWhatsappStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/check_whatsapp_status`);
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  // Método para adicionar ao InboxesAPI
  disconnectWhatsappInstance(inboxId) {
    return axios.post(`${this.url}/${inboxId}/whatsapp_disconnect`);
  }

  setSettingsWhatsappCortexwoot(inboxId, customAttributes) {
    return axios.post(
      `${this.url}/${inboxId}/custom_attributes_evolution_api`,
      {
        custom_attributes: customAttributes,
      }
    );
  }

  syncTemplates(inboxId) {
    return axios.post(`${this.url}/${inboxId}/sync_templates`);
  }

  createWhatsAppTemplate(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/create_template`, {
      template,
    });
  }

  deleteWhatsAppTemplate(inboxId, templateName) {
    return axios.delete(`${this.url}/${inboxId}/delete_template`, {
      params: { template_name: templateName },
    });
  }

  // ===== Baileys specific methods =====

  baileysCreateInstance(inboxId, config = {}) {
    return axios.post(`${this.url}/${inboxId}/baileys_create_instance`, config);
  }

  baileysGetQRCode(inboxId) {
    return axios.get(`${this.url}/${inboxId}/baileys_qrcode`);
  }

  baileysGetPairingCode(inboxId, renew = false) {
    // Código novo é POST: gasta 1 dos 3 por 10 min no gateway, e GET pode ser repetido sozinho.
    const url = `${this.url}/${inboxId}/baileys_pairing_code`;
    return renew ? axios.post(url) : axios.get(url);
  }

  baileysGetStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/baileys_status`);
  }

  baileysConnect(inboxId, options = {}) {
    return axios.post(`${this.url}/${inboxId}/baileys_connect`, options);
  }

  baileysDisconnect(inboxId) {
    return axios.post(`${this.url}/${inboxId}/baileys_disconnect`);
  }

  baileysUpdateConfig(inboxId, config) {
    return axios.patch(`${this.url}/${inboxId}/baileys_config`, config);
  }

  // Conecta com uma sessão do WhatsApp Web já autenticada (JSON da extensão
  // Passkey Linker), quando o pareamento por QR Code falha por causa da passkey.
  baileysImportCreds(inboxId, creds) {
    return axios.post(`${this.url}/${inboxId}/baileys_import_creds`, { creds });
  }
}

export default new Inboxes();
